import { Toast } from "vant-ui";
import axios from "#/net/axios.js";
import commonUtil from "@/utils/common.js"
import { setOrderInfoShop, setOrderDetailShop } from "@/storage/orderDetail.js"
import AESUtil from "@/utils/AESUtil";

/**
 * vuex
 */
const state = {
    shopInfo: {
        shopLogo: '',
        shopNickname: '',
        shopAnnouncement: '',
        scoring: '',
        openTime: '',
        offTime: '',
        shopBroadcastPictures: [],
        ifShopOpen: false,
    },

    shopInfoDetail: {
        address: "",
        bankCardNum: "",
        businessLicense: "",
        city: "",
        commission: 0,
        cooperationType: 2,
        county: "",
        id: -1,
        img: "",
        isSelfEmployed: true,
        isSignPact: true,
        isSupportInvoicing: true,
        latitude: "",
        legalPersonIdcardPositive: "",
        legalPersonIdcardReverse: "",
        linkMobilePhone: "",
        linkName: "",
        linkPersonJob: "",
        linkTel: "",
        longitude: "",
        margin: 0,
        name: "",
        namePinyin: "",
        openAccountBank: "",
        province: "",
        qq: "",
        scope: 2,
        secondLinkMobilePhone: "",
        secondLinkName: "",
        settlementCycle: 14,
        shopName: "",
        shopNamePinyin: "",
        signTime: "",
        supplierTypes: [],
        wechat: "",
    },
}

const getters = {

}

const mutations = {
    setShopInfo(state, { shopId, data }) {
        //
        state.shopInfo = data;

        //
        setOrderInfoShop(shopId, data);
    },

    clearShopInfo(state) {
        state.shopInfo = {
            shopLogo: '',
            shopNickname: '',
            shopAnnouncement: '',
            scoring: '',
            openTime: '',
            offTime: '',
            shopBroadcastPictures: [],
            ifShopOpen: false,
            ifBusiness: 0, // 0 at business, 1 not at businness
        };
    },

    /**
     * 
     * @param {*} state 
     */
    setShopInfoDetail(state, { shopId, data })
    {
        state.shopInfoDetail = data;
        
        //
        setOrderDetailShop(shopId, data);
    },

    clearShopInfoDetail(state) {
        state.shopInfoDetail = {
            address: "",
            bankCardNum: "",
            businessLicense: "",
            city: "",
            commission: 0,
            cooperationType: 2,
            county: "",
            id: 900,
            img: "", 
            isSelfEmployed: true,
            isSignPact: true,
            isSupportInvoicing: true,
            latitude: "",
            legalPersonIdcardPositive: "",
            legalPersonIdcardReverse: "",
            linkMobilePhone: "",
            linkName: "",
            linkPersonJob: "",
            linkTel: "",
            longitude: "",
            margin: 0,
            name: "",
            namePinyin: "",
            openAccountBank: "",
            province: "",
            qq: "",
            scope: 2,
            secondLinkMobilePhone: "",
            secondLinkName: "",
            settlementCycle: 14,
            shopName: "",
            shopNamePinyin: "",
            signTime: "",
            supplierTypes: [],
            wechat: "",
        };
    },
}

const actions = {
    getShopMsg({ commit }, shopId, cb) {
        //
        axios.shop
            .get('/shophome/getShopMsg.do', {
                shopId,
            })
            .then(({ statusCode, msg, data }) => {
                if (statusCode !== '200') {
                    return this.Toast(`获取店铺信息失败, ${msg}`)
                }

                //
                let shopInfo = data;

                //
                shopInfo.shopBroadcastPictures = JSON.parse(
                    data.shopBroadcastPictures
                )
                
                //
                if (shopInfo.openTime == '') {
                    shopInfo.openTime = '00:00'
                }

                //
                if (shopInfo.offTime == '') {
                    shopInfo.offTime = '24:00'
                }

                //
                shopInfo.ifShopOpen = commonUtil.checkOpenTime(
                    shopInfo.openTime,
                    shopInfo.offTime
                )
                
                //
                commit("setShopInfo", {
                    shopId,
                    data: shopInfo,
                });

                if (cb)
                {
                    cb(null);
                }
            })
            .catch((e) => {
                Toast(e.toString())

                if(cb)
                {
                    cb(e);
                }
            })
    },

    async getShopInfoDetail({ commit }, {
        shopId,
        cb,
    }) {
        //
        axios.shop
            .get('/supplierInfo/selectOneNew.do', {
                id: encodeURI(await AESUtil.encrypt(shopId)),
                timestamp: Date.now(),
            })
            .then(({ statusCode, msg, data }) => {
                if (statusCode !== '200') {
                    return Toast(`获取店铺详情失败, ${msg}`)
                }

                //
                AESUtil.decrypt(data).then(res => {
                    commit("setShopInfoDetail", { shopId, data: JSON.parse(res) });
                });

                //
                if(cb)
                {
                    AESUtil.decrypt(data).then(res => {
                        cb(null, res);
                    });
                }
            })
            .catch((e) => {
                //
                Toast(e.toString())

                //
                if (cb) {
                    cb(e)
                }
            })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
